const Account = () => import(/* webpackPrefetch: true, webpackChunkName: 'account' */ 'wap/views/account/routes/Account.vue')
const WithdrawPassword = () => import(/* webpackPrefetch: true, webpackChunkName: 'account' */ 'wap/views/account/routes/WithdrawPassword.vue')

const routes = [
  {
    path: '/me/info/withdraw_password',
    name: 'withdrawPassword',
    component: WithdrawPassword
  },
  {
    path: '/me/info',
    name: 'account',
    component: Account,
    meta: {
      title: 'My Account Information | My Account | MSport'
    }
  }
]

export default routes
